// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608200734/js/" + chunkId + "." + {"44":"6b9b4279","225":"64b96c18","481":"b77c283f","486":"62ab5298","770":"25f1abbd"}[chunkId] + ".0.23044676807009445.chunk.js";
};